import {Component, ElementRef, Inject, Injector, HostListener} from '@angular/core';
import {NgbActiveModal, NgbModalRef, NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AppComponentBase} from '../../../../services/AppComponentBase';
import {showBuyingProcessModal} from '../../../appstore/appproduct-buypopup/appproduct-buypopup-modal';
import {AppstoreSuccessComponent} from '../../../appstore/appstore-success-notification/appstore-success-notification.component';
import {IAppStoreProduct} from '../../../appstore/interfaces/appstore-interfaces';
import {Utils} from '../../../../utils';
import {ScannerTrialReminder} from '../ScannerTrialReminder/ScannerTrialReminder.component';




@Component({
    selector: "modal-ScannerTrialReminder-mobile",
    template: require('./ScannerTrialReminderMobile.component.html'),
    styles: [require('./ScannerTrialReminderMobile.component.css')]
})

export class ScannerTrialReminderMobile extends ScannerTrialReminder {

    constructor(

        injector: Injector,
        public activeModal: NgbActiveModal,
    ) {
        super(injector,activeModal);


    }

}


